import(/* webpackMode: "eager" */ "/home/w3era/next_academy_w3era/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/next_academy_w3era/src/components/header/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/w3era/next_academy_w3era/src/components/OuterCourses.tsx");
